import styled from 'styled-components';
import { getSizeInRem } from '../../../methods/common.js';
import COLORS from '../../../constants/colors.js';
import '../../../constants/fonts.js';
import '../../../constants/theme.js';
import '../../../constants/files.js';
import '../../../constants/color-variant.js';
import '../../../constants/zIndexList.js';

const StyledBorderedCard = styled.div `
    padding: ${({ padded = true }) => (padded ? "1rem" : undefined)};
    border-radius: ${({ borderRadius = "8px" }) => borderRadius};
    border: 1px solid ${({ borderColor = COLORS.GREY_200 }) => borderColor};
    background-color: ${({ backgroundColor = "white" }) => backgroundColor};
    box-shadow: 0px 0px 24px -4px rgba(16, 24, 40, 0.1);
    width: ${(props) => getSizeInRem(props.width)};
    overflow: ${({ overflow = "hidden" }) => overflow};
`;

export { StyledBorderedCard };
//# sourceMappingURL=BordererCard.styles.js.map
